<template>
  <div class="form">
    <div class="avatar">
      <div class="id" v-if="role_id !== 40001">{{role}}</div>
      <div class="avatar" style="overflow:hidden">
        <img :src="avatar_url" style="width:100%;height:100%">
      </div>
    </div>
    <el-form label-width="100px" style="margin-top:10px">
      <el-form-item label="用户名:">
        <span>{{identify}}</span>
      </el-form-item>
      <el-form-item label="真实姓名:">
        <text-with-tip :content="real_name"/>
      </el-form-item>
      <el-form-item label="手机号码:" v-if="isCustom">
        <div v-if="phone"  class="form-flex">
          <span>{{phone}}</span>
          <span
            @click="bindPhone('rebind')"
            style="color: #00C4AA; cursor: pointer;"
          >修改手机号</span>
        </div>
        <div v-else class="pointer">
          <el-button
            class="m-r-5"
            type="primary"
            @click="bindPhone('bind')"
          >请点击绑定</el-button>
          <span style="color:red">绑定手机号可快捷登录哦</span>
        </div>
      </el-form-item>
      <el-form-item label="任职学校:" v-if="role_id === 10001 || role_id === 10002">
        <div class="form-flex">
          <span>{{user.unit_name}}</span>
          <!-- 有学校信息 => 未审核展示 => 审核不通过展示 -->
          <el-button
            :type="schoolInfo.handled ? schoolInfo.passed ? '' : 'danger' : 'warning'"
            size="mini"
            round
            :class="['reset-button', schoolInfo.handled ? schoolInfo.passed ? '' : 'reset-button-unpassed' : 'reset-button-handle']"
            v-if="schoolInfo ? schoolInfo.handled ? schoolInfo.passed ? false : true : true : false"
          >
            <span :class="['dot', schoolInfo.handled ? schoolInfo.passed ? '' : 'dot-red' : 'dot-yellow']"></span>
            {{schoolInfo.handled ? schoolInfo.passed ? '审核通过' : '审核不通过' : '审核中'}}
          </el-button>
          <!-- 有学校信息 => 已审核，且审核通过展示 -->
          <div v-else-if="schoolInfo ? schoolInfo.handled ? schoolInfo.passed ? true : false : false : false" style="white-space: nowrap;flex: 0 0 auto;">
            <el-tooltip class="item" effect="dark" content="" placement="top-start">
              <div slot="content" style="line-height: 20px">您的学校信息已审核通过，如需修改学校信息，请邮件联系我们；<br/>官方邮箱：codemao-edu@codemao.cn</div>
              <span>
                <i class="el-icon-question"></i>
                如何修改
              </span>
            </el-tooltip>
          </div>
        </div>
      </el-form-item>
      <div class="school-tips"
        v-html="lastMessage.content"
        v-if="lastMessage"
        @click="handleBindSchool($event, lastMessage)"
      >
      </div>
    </el-form>

    <school-form v-model="showChangeSchool" @on-succsss="changeSchoolSuccess"></school-form>
  </div>
</template>

<script>
import SchoolForm from './schoolForm.vue'
import { mapState } from 'vuex'

export default {
  components: { SchoolForm },

  data() {
    return {
      showChangeSchool: false
    }
  },

  computed: {
    ...mapState([
      'user'
    ]),

    lastMessage() {
      return this.$store.state.lastMessage
    },

    schoolInfo() {
      return this.$store.state.schoolInfo
    },

    real_name() {
      return this.$store.state.user.fullname
    },
    identify() {
      return (
        this.$store.state.user.username ||
        this.$store.state.user.phone ||
        this.$store.state.user.mail
      )
    },
    phone() {
      return this.$store.state.user.phone
    },
    avatar_url() {
      return this.$store.state.user.avatar_url
    },
    role() {
      const role_id = this.$store.state.user.role_id
      if (role_id === 10001) {
        return '教管'
      } else if (role_id === 10002) {
        return '教师'
      } else {
        return '学生'
      }
    },
    role_id() {
      return this.$store.state.user.role_id
    },
    isCustom() {
      const customInfo = JSON.parse(localStorage.getItem('customInfo'))
      return customInfo ? !customInfo.url.includes('/nc') : true
    }
  },

  methods: {
    bindPhone(type) {
      this.$store.commit('setState', {
        module: 'base',
        key: 'bindPhone',
        value: {
          type: type, // rebind | bind
          status: true
        }
      })
    },

    handleBindSchool(e, data) {
      const target = e.target
      // 只要点击则执行已阅读
      this.$store.dispatch('setInviteReadMessage', data.id)
      // 有选择学校关键字直接选择
      if (data.content.indexOf('选择学校') !== -1 && target.tagName.toLowerCase() === 'span') {
        this.showChangeSchool = true
      } else { // 避免点击最新消息后隐藏选择栏，其他非关键字消息，阅读后可消失掉
        this.$store.dispatch('getMessageLast')
      }
    },

    changeSchoolSuccess() {
      this.$store.dispatch('getSchoolInfo')
      this.$store.dispatch('getMessageLast')
      this.showChangeSchool = false
    }
  },

  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.dot{
  display: inline-block;
  width: 6px;
  height: 6px;
  margin: 0 5px;
  border-radius: 50%;
}
.dot-red{
  background-color: #f56c6c;
}
.dot-yellow {
  background-color: #FFA21F;
}
.form {
  display: flex;
  padding: 0 20px;
  flex-direction: column;
}
.avatar {
  width: 80px;
  height: 80px;
  // overflow: hidden;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  border: #ccc 1px solid;
  // overflow: hidden;
  font-size: 12px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 5px;
}
.el-form-item__label {
  font-size: 12px;
}
.foot {
  margin-top: 30px;
  width: 100%;
  text-align: center;
}
.id {
  width: 36px;
  height: 36px;
  border-radius: 20px;
  background: #fd8200;
  position: absolute;
  right: -16px;
  top: -10px;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 10px #fd8200;
  border: 2px #fff solid;
}
.form-flex {
  display: flex;
  justify-content: space-between;
  .flex-content {
    flex: 0 0 auto;
  }
}
.school-tips {
  padding: 15px 20px;
  border-radius: 4px;
  background: #FEF0EF;
  .school-change {
    color: #00C4AA;
    cursor: pointer;
  }
}
.reset-button {
  height: 34px;
  line-height: 34px;
  padding: 0 10px !important;
  border-color:transparent !important;
}
.reset-button-handle {
  color: #FFA21F;
  background-color: #FFFBE6;
  &:hover {
    color: #FFA21F;
    background-color: #FFFBE6;
  }
  &:focus {
    color: #FFA21F;
    background-color: #FFFBE6;
  }
}
.reset-button-unpassed {
  color: #F5222D;
  background: rgba(245, 34, 45, 0.1);
  &:hover {
    color: #F5222D;
    background: rgba(245, 34, 45, 0.1);
  }
  &:focus {
    color: #F5222D;
    background: rgba(245, 34, 45, 0.1);
  }
}
</style>
